module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectImage":"Select image"}}')
  delete Component.options._Ctor
}
